import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import { Iconify } from 'src/components';

export default function SegmentedControl({ tabs, value, onChange }) {
  return (
    <Box
      sx={{
        bgcolor: '#f1f5f9',
        borderRadius: '14px',
        p: '5px',
        display: 'flex',
        gap: '6px',
        flexWrap: 'wrap',
      }}
    >
      {tabs.map((tab) => {
        const isActive = value === tab.value;
        return (
          <Button
            key={tab.value}
            onClick={() => onChange(tab.value)}
            startIcon={tab.icon ? <Iconify icon={tab.icon} width={15} height={15} /> : undefined}
            sx={{
              textTransform: 'none',
              fontSize: '13px',
              px: 2,
              py: 0.75,
              borderRadius: '10px',
              bgcolor: isActive ? '#fff' : 'transparent',
              boxShadow: isActive ? '0 1px 3px rgba(0,0,0,0.08)' : 'none',
              color: isActive ? '#1e293b' : '#94a3b8',
              fontWeight: isActive ? 600 : 500,
              '&:hover': {
                bgcolor: isActive ? '#fff' : 'rgba(0,0,0,0.04)',
              },
            }}
          >
            {tab.label}
          </Button>
        );
      })}
    </Box>
  );
}

SegmentedControl.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
